import { History } from "history";
import { history } from "tsx/store/history";

import { IKeyValue, parseQueryParams } from "helpers/url";

export type IBrowserHistory = History;

class BrowserHistory {
  private browserHistory: IBrowserHistory;
  private locationEverChanged = false;

  constructor() {
    this.browserHistory = history;
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(6133): 'action' is declared but its value is never read.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.browserHistory.listen((location, action) => {
      const { state } = location;
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (state && (state as any).redirectFromAccountsState) {
        // don't treat redirection from 'state' param from Accounts
        // as something that changed location inside the app
        return;
      }
      this.locationEverChanged = true;
    });
  }

  get browserHistoryObject(): IBrowserHistory {
    return this.browserHistory;
  }

  get hasLocationEverChanged(): boolean {
    return this.locationEverChanged;
  }

  get queryString(): string {
    return (this.browserHistory.location.search || "").replace("?", "");
  }

  get queryParams(): IKeyValue<string> {
    return parseQueryParams(this.queryString);
  }

  get pathname(): string {
    return this.browserHistory.location.pathname;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  push = (pathname: string, search = "") => {
    this.browserHistory.push({
      pathname,
      search,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  pushQueryString = (search: string) => {
    this.browserHistory.push({
      ...this.browserHistory.location,
      search,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  replaceQueryString = (search: string) => {
    this.browserHistory.replace({
      ...this.browserHistory.location,
      search,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  replace = (pathname: string, search = "") => {
    this.browserHistory.replace({
      pathname,
      search,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeHash = () => {
    this.browserHistory.push({
      ...this.browserHistory.location,
      hash: "",
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  replaceUrl = (url: string) => {
    this.browserHistory.replace(url);
  };
}

export default new BrowserHistory();
